import { PANJWE } from '@visa/lib-webcrypto';

export async function encryptData<Type>(data?: Type) {
  if (!data) {
    return null;
  }

  const visaCert = window.VISA_GLOBALS.srcEnvConfig.cert;

  try {
    const crypt = new PANJWE(visaCert.kid, visaCert.publicKey);
    return crypt.encrypt(JSON.stringify(data));
  } catch (_) {
    return null;
  }
}
